import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/video-covers/hero.jpg")